import { motion } from "framer-motion";
import { CheckCircle2, Copy, PartyPopper, X, Info } from "lucide-react";
import React from "react";

/**
 * Toast notification component
 * @param {Object} props
 * @param {string} props.message - The message to display
 * @param {string} props.type - The type of toast (success, error, celebration, copy, info)
 * @param {Function} props.onClose - Function to call when closing the toast
 * @returns {JSX.Element}
 */
const Toast = ({ message, type, onClose }) => {
  // Determine which icon to show based on the toast type
  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle2 className="tw-w-5 tw-h-5 tw-text-emerald-500" />;
      case "celebration":
        return <PartyPopper className="tw-w-5 tw-h-5 tw-text-amber-500" />;
      case "copy":
        return <Copy className="tw-w-5 tw-h-5 tw-text-emerald-500" />;
      case "info":
        return <Info className="tw-w-5 tw-h-5 tw-text-blue-500" />;
      default:
        return null;
    }
  };

  // Determine the position based on the toast type
  const position = type === "info" ? "tw-left-4" : "tw-right-4";

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className={`tw-fixed tw-bottom-4 ${position} tw-z-50`}
    >
      <div className="tw-bg-white tw-rounded-xl tw-shadow-lg tw-p-4 tw-flex tw-items-center tw-space-x-3">
        {getIcon()}
        <p
          className={`${
            type === "info" ? "tw-text-gray-500 tw-text-sm" : "tw-text-gray-700"
          }`}
        >
          {message}
        </p>
        <button
          onClick={onClose}
          className="tw-p-1 hover:tw-bg-gray-100 tw-rounded-full"
        >
          <X className="tw-w-4 tw-h-4 tw-text-gray-500" />
        </button>
      </div>
    </motion.div>
  );
};

export default Toast;
